var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6267 29.932C23.6682 29.932 30.1871 23.4089 30.1871 15.3622C30.1871 7.31555 23.6682 0.792419 15.6267 0.792419C7.5853 0.792419 1.06641 7.31555 1.06641 15.3622C1.06641 23.4089 7.5853 29.932 15.6267 29.932Z",
    fill: "#FFDC00",
    stroke: "#434341",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53394 18.9706C11.0117 23.9422 19.9225 23.9422 22.7239 18.9706H8.53394Z",
    fill: "#FFDC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53394 18.9706C11.0117 23.9422 19.9225 23.9422 22.7239 18.9706",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9209 12.6911C8.30406 11.6985 9.02358 11.0296 9.84951 11.0296C10.6754 11.0296 11.3651 11.6686 11.7526 12.6229",
    fill: "#FFDC00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9209 12.6911C8.30406 11.6985 9.02358 11.0296 9.84951 11.0296C10.6754 11.0296 11.3651 11.6686 11.7526 12.6229",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 12.6911C20.2504 11.6985 20.9699 11.0296 21.7958 11.0296C22.6217 11.0296 23.3114 11.6686 23.6989 12.6229",
    fill: "#FFDC00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8672 12.6911C20.2504 11.6985 20.9699 11.0296 21.7958 11.0296C22.6217 11.0296 23.3114 11.6686 23.6989 12.6229",
    stroke: "#434341",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiley);
export default __webpack_public_path__ + "static/media/smiley.9c5efebbb3224dcd476bddb0fd5eb759.svg";
export { ForwardRef as ReactComponent };